// extracted by mini-css-extract-plugin
module.exports = {"OutOfStock":"outOfStock_OutOfStock__MEKaE","title":"outOfStock_title__nPY_g","subtitle":"outOfStock_subtitle___gn_x","actions":"outOfStock_actions__3B4po"};